import { FC, useState } from 'react';
import { TabletFilterAmountRange } from './shared/TabletFilterAmountRange';
import { TabletFilterContainer } from './shared/TabletFilterContainer';
import { TabletFilterSection } from './shared/TabletFilterSection';
import styles from './shared/TabletFilterContainer.module.scss';

export interface PriceFilterProps {
  minValue?: number;
  maxValue?: number;
  onChange: (min?: number, max?: number) => void;
  onReset: () => void;
  onApply: () => void;
  show?: boolean;
  fromPlaceholder: string;
  toPlaceholder: string;
}

export const TabletPriceFilter: FC<PriceFilterProps> = ({
  minValue,
  maxValue,
  onChange,
  show,
  fromPlaceholder,
  toPlaceholder,
}) => {
  const [localMin, setLocalMin] = useState<string>(minValue?.toString() || '');
  const [localMax, setLocalMax] = useState<string>(maxValue?.toString() || '');

  const handleMinChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMin(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(numValue, maxValue);
  };

  const handleMaxChange = (value: string | number) => {
    const stringValue = String(value);
    setLocalMax(stringValue);
    const numValue = stringValue === '' ? undefined : Number(stringValue);
    onChange(minValue, numValue);
  };

  return (
    <TabletFilterContainer className={styles.amount}>
      <TabletFilterSection>
        <TabletFilterAmountRange
          show={show}
          fromValue={localMin}
          toValue={localMax}
          onFromChange={handleMinChange}
          onToChange={handleMaxChange}
          fromPlaceholder={fromPlaceholder}
          toPlaceholder={toPlaceholder}
          hideSearchIcon={true}
        />
      </TabletFilterSection>
    </TabletFilterContainer>
  );
};
